import styled from 'styled-components';

export const ScheduleContainerStyled = styled.div`
  max-width: 920px;

  & .custom-select-container {
    width: 130px;
  }
  & .custom-select {
    outline-color: ${({ theme }) => theme.colors.disableText};
    border-radius: 6px;
  }
  & .custom-option {
    padding: 3px 5px;
  }
`;
